import { FaqSection } from '@/shared/ui/FaqSection'

import { catalogFaqApi } from '../api/catalog-faq-api'

import cl from './catalog-faq.module.scss'

type CatalogFaqProps = {
	id: string
	title: string
}

export const CatalogFaq = (props: CatalogFaqProps) => {
	const { id, title } = props
	const { data } = catalogFaqApi.useGetCatalogFaqQuery({ id })

	const adptedItems = data?.map(([question, answer]) => ({ question, answer }))

	if (!adptedItems?.length) return null

	return (
		<section className={cl.section}>
			{title && <h2 className={cl.title}>{title}</h2>}
			<FaqSection items={adptedItems} />
		</section>
	)
}
